import { provideState } from '@ngrx/store';

import { pocketFeature } from './pocket.reducer';

export const pocketStore = [provideState(pocketFeature)];
